// extracted by css-extract-rspack-plugin
export default {"browseContainer":"warDK","browseHeader":"ccJbd","browseMain":"mVLeV","centeredEmptyState":"gD5nX","learnAboutDataIcon":"BoHvF"};